import { apiCall } from './gqlClient';

const GETANALYTICS_QUERY = `
  query getAnalytics {
    getAnalytics
    {
      providersAll
			usersAll
			ordersAll
			users
			providers
			orders
      ...fragments
    }
  }`;

export const getAnalyticsApiCall = async (fragments = null) => apiCall({ query: GETANALYTICS_QUERY, variables: {}, fragments });
